// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"24":"bd8abcfe","201":"099588a7","255":"3fae68ac","278":"fa6590c1","372":"168fb071","434":"d0aec7f9","539":"c694aa44","541":"643420dd","787":"07224cef","815":"c679fcf7","849":"0c48fc6d","856":"217a0d10"}[chunkId] + ".chunk.js";
};